import { render, staticRenderFns } from "./create-edit-question-modal.vue?vue&type=template&id=9ca87f16&scoped=true&"
import script from "./create-edit-question-modal.vue?vue&type=script&lang=ts&"
export * from "./create-edit-question-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca87f16",
  null
  
)

export default component.exports